import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative isolate overflow-hidden bg-gray-900 px-6 py-24 sm:py-28 lg:px-8" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mx-auto max-w-7xl px-6 lg:px-8" }
const _hoisted_4 = { class: "mx-auto max-w-xl lg:mx-0" }
const _hoisted_5 = { class: "text-3xl font-bold tracking-tight text-white sm:text-4xl" }
const _hoisted_6 = { class: "mt-6 text-lg leading-8 text-white" }

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination, EffectFade } from 'swiper/modules';
import image1 from '@/assets/images/header/color-run.jpeg';
import image2 from '@/assets/images/header/desert-quad.jpeg';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
// import 'swiper/swiper-bundle.css';



export default /*#__PURE__*/_defineComponent({
  __name: 'BuyerHeroComponent',
  setup(__props) {

const swiperModules = [ Autoplay, Navigation, Pagination, EffectFade ];

const onSwiper = (swiper: any) => {
  console.log(swiper);
};
const onSlideChange = () => {
  console.log('slide change');
};

const slides = [
  {
    id: 1,
    image: image1,
    title: 'Discover Local Events!',
    subtitle: 'Step into a vibrant world of local activities and events, designed to entertain, educate, and inspire. Find it all in one place.'
  },
  {
    id: 2,
    image: image2,
    title: 'Find Your Next Adventure!',
    subtitle: 'From intimate local gatherings to big events, set off on a journey where unforgettable experiences, connections, and memories await.'
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Swiper), {
    modules: swiperModules,
    effect: 'fade',
    pagination: {
      clickable: true
    },
    autoplay: {
      delay: 15000,
      disableOnInteraction: false,
    },
    "slides-per-view": 1,
    "space-between": 50,
    onSwiper: onSwiper,
    onSlideChange: onSlideChange
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(slides, (slide) => {
        return _createVNode(_unref(SwiperSlide), {
          key: slide.id
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("img", {
                src: slide.image,
                alt: "",
                class: "absolute inset-0 -z-10 h-full w-full object-cover"
              }, null, 8, _hoisted_2),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", _hoisted_5, _toDisplayString(slide.title), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(slide.subtitle), 1)
                ])
              ])
            ])
          ]),
          _: 2
        }, 1024)
      }), 64))
    ]),
    _: 1
  }))
}
}

})